import React from "react";
import HiringFooter from "./HiringFooter";
import Logo from "./job_description/Logo";

export default ({ logo, name, url, colorHeaderBg, colorHeaderText }) => (
  <>
    <div
      className="pt-4 pb-6 mb-8 xl:pt-6 xl:pb-10 xl:mb-10"
      style={{ backgroundColor: colorHeaderBg }}
    >
      <div className="container">
        {url && (
          <div className="mb-4 xl:mb-8">
            <a
              href={url}
              className="text-xs font-medium underline xl:text-lg"
              style={{ color: colorHeaderText }}
            >
              Home
            </a>
          </div>
        )}
        {(logo || name) && (
          <div className="mb-4 xl:mb-5">
            <Logo
              logo={logo}
              name={name}
              colorHeaderText={colorHeaderText}
              url={url}
            />
          </div>
        )}

        <h1
          className="mb-2 text-3xl font-semibold xl:text-5xl py-4"
          style={{ color: colorHeaderText || "#000" }}
        >
          Page Currently Unavailable
        </h1>
      </div>
    </div>

    <HiringFooter />
  </>
);
